import { Box, Flex, Stack } from "../mantine-passthroughs/index.js";
import { Subtitle1 } from "../typography/Subtitle1.js";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/definition-list/DefinitionList.tsx
const DefinitionList = ({ compact = true, inline, items }) => {
	return /* @__PURE__ */ jsx(Stack, {
		gap: compact ? "xs" : "sm",
		children: items.map(({ title, body, key }) => {
			if (inline) return /* @__PURE__ */ jsxs(Flex, {
				gap: "xs",
				"data-testid": key,
				children: [/* @__PURE__ */ jsx(Subtitle1, { children: title }), /* @__PURE__ */ jsx(Box, { children: body })]
			}, key);
			return /* @__PURE__ */ jsxs(Stack, {
				gap: compact ? "xxxs" : "xxs",
				"data-testid": key,
				children: [title ? /* @__PURE__ */ jsx(Subtitle1, { children: title }) : null, /* @__PURE__ */ jsx(Box, { children: body })]
			}, key);
		})
	});
};

//#endregion
export { DefinitionList };